import '../skin/icons/font-awesome-4.7.0/css/font-awesome.min.css';
import '../skin/icons/icofont/icofont.min.css';